module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar customNavbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.root()
      }
    }
  }, [_c('img', {
    staticClass: "logoClass",
    attrs: {
      "src": "/static/logo.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.root()
      }
    }
  }, [_vm._v("Inicio")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.about()
      }
    }
  }, [_vm._v("Nosotros")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.products()
      }
    }
  }, [_vm._v("Productos")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItemSelected"
  }, [_vm._v("Noticias")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.contact()
      }
    }
  }, [_vm._v("Contacto")]), _vm._v(" "), (_vm.isLogged) ? _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Cerrar Sesión")]) : _c('a', {
    staticClass: "navbar-item customNavbarItem",
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Iniciar Sesión")])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds"
  }, [_c('h2', {
    staticClass: "title is-2"
  }, [_vm._v("Noticias")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newsSearch),
      expression: "newsSearch"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('newsSearch')
    },
    attrs: {
      "type": "text",
      "name": "newsSearch"
    },
    domProps: {
      "value": (_vm.newsSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newsSearch = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newsSearch')),
      expression: "errors.has('newsSearch')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newsSearch')))])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button customButton",
    on: {
      "click": _vm.getNews
    }
  }, [_vm._v("Buscar")]), _vm._v(" "), _c('button', {
    staticClass: "button customButton",
    on: {
      "click": _vm.cleanSearch
    }
  }, [_vm._v("Limpiar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  })]), _vm._v(" "), _vm._l((_vm.newsList), function(newsItem) {
    return _c('article', {
      key: newsItem.id,
      staticClass: "message is-info"
    }, [_c('div', {
      staticClass: "message-header"
    }, [_c('p', [_c('i', [_vm._v(_vm._s(newsItem.dateStr))])])]), _vm._v(" "), _c('div', {
      staticClass: "message-body"
    }, [_c('div', {
      staticClass: "newsContent",
      staticStyle: {
        "height": "70px"
      }
    }, [(newsItem.firstImage != null) ? _c('img', {
      staticClass: "newsImage",
      attrs: {
        "src": _vm.multimediaBase + newsItem.firstImage,
        "width": "150px",
        "height": "50px",
        "align": "left"
      }
    }) : _vm._e(), _vm._v(" "), _c('h2', {
      staticClass: "newsTitle"
    }, [_c('i', [_c('b', [_vm._v(_vm._s(newsItem.title))])])]), _vm._v(" "), _c('p', {
      staticClass: "newsInfo"
    }, [_vm._v(_vm._s(newsItem.message))]), _vm._v(" "), _c('a', {
      staticClass: "newsLink",
      staticStyle: {
        "margin-top": "30px"
      },
      on: {
        "click": function($event) {
          _vm.newsDetail(newsItem.id)
        }
      }
    }, [_vm._v("Leer más")])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "column"
  })])]), _vm._v(" "), _c('FooterComponent')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48279b9b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsComponent.vue
// module id = 82
// module chunks = 0